<script>
  import {External, M} from "../external";

  let url = "https://" + External.primaryDomain;
  let source = "";
  let medium = "";
  let campaign = "";
  let finalUrl = url;
  let finalParameters = "";

  let keyup = () => {
    let params = "";

    finalParameters = "";
    finalUrl = "";
    if (url.toLowerCase().startsWith("http://") || url.toLowerCase().startsWith("https://")) {
      finalUrl = url;
    } else {
      finalUrl = "https://" + url;
    }

    if (source) {
      params += "utm_source=" + encodeURIComponent(source);
    }

    if (medium) {
      if (params) {
        params += "&";
      }
      params += "utm_medium=" + encodeURIComponent(medium);
    }

    if (campaign) {
      if (params) {
        params += "&";
      }
      params += "utm_campaign=" + encodeURIComponent(campaign);
    }

    if (params) {
      let separator = url.endsWith("?") || url.endsWith("&") ? "" : url.includes("?") ? "&" : "?";
      finalUrl += separator + params;
      finalParameters = "?" + params;
    }
  };

  let copy = () => {
    External.Tools.copyToClipboard(finalUrl);
    External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> add_link </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-10 t-center h4-bigger">{M.TRACKING_LINK_BUILDER}</h4>
  <span class="light-gray-text t-center col20 f-left mb-25 padded-text">
    {M.TRACKING_LINK_BUILDER_DESC}
  </span>
  <div class="col20 f-left mt-10">
    <div class="popup-input-wrapper col20">
      <h5>{M.PAGE_URL}</h5>
      <input type="text" bind:value={url} on:keyup={keyup} placeholder="{M.ENTER_HERE}" />
      {url}
    </div>
    <div class="popup-input-wrapper col20">
      <h5>{M.SOURCE} <span class="small-info-text f-none inline-block ml-10">{M.SOURCE_EXAMPLE}</span></h5>
      <input type="text" bind:value={source} on:keyup={keyup} placeholder="{M.ENTER_HERE}" />
    </div>
    <div class="popup-input-wrapper col20">
      <h5>{M.UTM_MEDIUM} <span class="small-info-text f-none inline-block ml-10">{M.MEDIUM_EXAMPLE}</span></h5>
      <input type="text" bind:value={medium} on:keyup={keyup} placeholder="{M.ENTER_HERE}" />
    </div>
    <div class="popup-input-wrapper col20">
      <h5>{M.CAMPAIGN} <span class="small-info-text f-none inline-block ml-10">{M.CAMPAIGN_EXAMPLE}</span></h5>
      <input type="text" bind:value={campaign} on:keyup={keyup} placeholder="{M.ENTER_HERE}" />
    </div>
    <h4 class="col20 f-left roboto t-left">{M.YOUR_TRACKING_URL}</h4>
    <div class="col20 f-left affiliate-link-wrapper flex align-center space-between mt-5 mb-15 white-bg affiliate-link-wrapper-big">
      <div class="flex align-center flex-row col20">
        <svg xmlns="http://www.w3.org/2000/svg" class="flex-none" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
        </svg>
        <h4 class="flex-1" style="padding: 0; word-break: break-all;">{finalUrl}</h4>
        <a class="copy-affiliate-link flex-none rounded-effect flex-none" on:click={copy}>{M.COPY}</a>
      </div>
    </div>
    {#if finalParameters}
      <h5 class="col20 f-left t-left" style="line-height: 1.3; word-break: break-all;">
        {M.ADD_URL_PARAM} <b class="system-text-color">{finalParameters}</b>
      </h5>
    {/if}
  </div>
</div>
